import React, { useState } from "react";
import { Card, Divider, Grid, Header, Icon, Input, Button } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { SetStartDate, SetEndDate } from "../../../../redux/actions/mainActions"
import { useSelector, useDispatch } from 'react-redux';
import GuestsTab from "../GuestsTab/GuestsTab";
import bgimg from "../../../../assets/images/bg-stripped.jpeg"
const ReservationCard = () => {

    const { t } = useTranslation();
    const dispatch = useDispatch()

    const startDate = useSelector((state) => state.main.startDate)
    const endDate = useSelector((state) => state.main.endDate)
    const lang = useSelector((state) => state.main.lang)



    const renderStartDatePicker = () => {
        return lang === "fa-IR" ?
            <DatePicker
                render={(value, openCalendar) => {
                    return (
                        <Input onClick={openCalendar} value={startDate} placeholder={t("home:CheckinSelect")} readOnly />
                    )
                }}
                mapDays={({ date }) => {
                    var today = new Date()
                    
                    if (date < today) return {
                      disabled: true,
                      style: {  backgroundImage: `url(${bgimg})`,     backgroundSize: "contain"},
                    }
                  }}
                calendarPosition="bottom-right"
                className="calendar-class"
                hideOnScroll={true}
                calendar={persian}
                locale={persian_fa}
                onChange={(date) => {
                    dispatch(SetStartDate(new Date(date).toLocaleDateString('fa-IR')))

                }}
                value={startDate}
            />
            : <DatePicker
                render={(value, openCalendar) => {
                    return (
                        <Input onClick={openCalendar} value={startDate} placeholder={t("home:CheckinSelect")} readOnly />
                    )
                }}
                mapDays={({ date }) => {
                    var today = new Date()
                    
                    if (date < today) return {
                      disabled: true,
                      style: {  backgroundImage: `url(${bgimg})`,     backgroundSize: "contain"},
                    }
                  }}
                calendarPosition="bottom-right"
                className="calendar-class"
                hideOnScroll={true}
                onChange={(date) => {
                    console.log(date)
                    dispatch(SetStartDate(date))
                }}
                value={startDate}
            />


    }

    const renderEndDatePicker = () => {
        return lang === "fa-IR" ?
            <DatePicker

                render={(value, openCalendar) => {
                    return (
                        <Input onClick={openCalendar} value={endDate} placeholder={t("home:CheckoutSelect")} readOnly />
                    )
                }}
                mapDays={({ date }) => {
                    var today = new Date()
                    
                    if (date < today) return {
                      disabled: true,
                      style: {  backgroundImage: `url(${bgimg})`,     backgroundSize: "contain"},
                    }
                  }}
                calendarPosition="bottom-right"
                className="calendar-class"
                hideOnScroll={true}
                calendar={persian}
                locale={persian_fa}
                onChange={(date) => {
                    dispatch(SetEndDate(new Date(date).toLocaleDateString('fa-IR')))

                }}
                value={endDate}
            />
            : <DatePicker
                render={(value, openCalendar) => {
                    return (
                        <Input onClick={openCalendar} value={endDate} placeholder={t("home:CheckoutSelect")} readOnly />
                    )
                }}
                mapDays={({ date }) => {
                    var today = new Date()
                    
                    if (date < today) return {
                      disabled: true,
                      style: {  backgroundImage: `url(${bgimg})`,     backgroundSize: "contain"},
                    }
                  }}
                calendarPosition="bottom-right"
                className="calendar-class"
                hideOnScroll={true}
                onChange={(date) => {
                    console.log(date)
                    dispatch(SetEndDate(date))
                }}
                value={endDate}
            />


    }
    return <Card className="w-100 m-1-t m-1-b">

        <Card.Content>
            <Card.Header>

            </Card.Header>
            <Card.Description className="p-1-r p-1-l">

                <div className="d-flex flex-row align-items-center">
                    {t("property:PricePerNight")} :
                    <Header size='medium' className="m-05-r m-05-l">1,500,000</Header>
                    {t("property:Toman")}
                </div>
                <Divider />
                <Grid className="p-1-r p-1-l" columns={2}>
                    <Grid.Row className="p-0-b">
                        <Header size='small'>{t("property:TravelDate")}</Header>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column textAlign="center" className="p-0-r p-0-l">
                            {renderStartDatePicker()}
                        </Grid.Column>
                        <Grid.Column textAlign="center" className="p-0-r p-0-l">
                            {renderEndDatePicker()}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Divider />

                <Grid className="p-1-r p-1-l" columns={1}>
                    <Grid.Row className="p-0-b">
                        <Header size='small'>{t("property:NumberOfPeople")}</Header>
                    </Grid.Row>
                    <Grid.Row className="p-0-t p-0-b">
                        <Grid centered verticalAlign="middle" className="m-0  bg-white w-100" >
                            <Grid.Column className="p-0" width={16}><GuestsTab /></Grid.Column>
                        </Grid>
                    </Grid.Row>
                </Grid>
                <Divider />
                <Button color="blue" className="rounded-30 w-100 p-1" >{t("property:SubmitAReservationRequest")} ({t("property:Free")})</Button>
                <Divider />

                <div className="d-flex flex-row align-items-center justify-content-between">
                    <Header className="m-0" size='medium'>{t("property:Total")}</Header>
                    <Header className="m-0" size='medium'> 1٫100٫000  {t("property:Toman")}</Header>
                </div>

                <Divider />

                <div className="d-flex flex-row align-items-center justify-content-between">
                    <p className="m-0 font-small" >{t("property:Prepayment")} ({t("property:AfterHostApproval")})</p>
                    <p className="m-0 font-small" > 1٫100٫000  {t("property:Toman")}</p>
                </div>
            </Card.Description>
        </Card.Content>

    </Card>
}
export default ReservationCard